import { Analytics } from '@vercel/analytics/react';
import './App.css';
import MapComponent from "./components/features/map-component/map-component";
import Topbar from "./components/core/components/topbar/topbar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {BrowserRouter, Route, Router, Routes} from "react-router-dom";
import SelectMap from "./components/features/select-map/select-map";

function App() {
    return (
        <div className="app-container">
            <BrowserRouter>
                <Topbar />
                <div id="app-content">
                    <Routes>
                        <Route path="/" element={<SelectMap />} />
                        <Route path="/maps" element={<SelectMap />} />
                        <Route path="/maps/:gameMap" element={<MapComponent />} />
                    </Routes>
                </div>
            </BrowserRouter>
            <ToastContainer
                id="custom-toast-container"
                style={{top: 60}}
                position="top-right"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                draggable
                theme="dark"
            />
            <Analytics />
        </div>
    );
}


export default App;
